import { render, staticRenderFns } from "./horarioIngreso.vue?vue&type=template&id=1fca70a8&"
import script from "./horarioIngreso.vue?vue&type=script&lang=js&"
export * from "./horarioIngreso.vue?vue&type=script&lang=js&"
import style0 from "./horarioIngreso.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports